import { Component } from '@angular/core';

import { PaymentsService } from 'src/app/core/api/services';

@Component({
    selector: 'app-reseller-payments',
    templateUrl: './reseller-payments.component.html',
    standalone: false
})
export class ResellerPaymentsComponent {
  //#region Properties
  getTableDataApiMethodName: string =
    'paymentsGetResellerPaymentsWithPagination';
  pageTitle: string = 'pages.payments.resellerTitle';

  //#endregion

  constructor(protected currentService: PaymentsService) {}
}
